import styled from '@emotion/styled';
import { Prismic, WrapText } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { PageIntro } from '../components/intro/PageIntro';
import { KauphollNews } from '../components/kaupholl-news/KauphollNews';

interface IProps {
  title: Prismic.RichText;
  description: Prismic.RichText;
  count: number;
}

const P = styled.p`
  margin-top: 72px !important;
`;

const H2 = styled.h2`
  margin-top: 72px;
`;

export function KauphollNewsContainer({ title, description, count }: IProps) {
  return (
    <Segment>
      <PageIntro
        title={
          <WrapText isArticle={false}>
            <H2>{Prismic.text(title)}</H2>
          </WrapText>
        }
        copySize={true}
        copy={
          <WrapText isArticle={false}>
            <P>{Prismic.text(description)}</P>
          </WrapText>
        }
      />
      <KauphollNews count={count} />
    </Segment>
  );
}
